import React from "react";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import EmailIcon from "@mui/icons-material/Email";
import "./Officers.css";
import Christa from "../imgs/Christa.jpeg";
import Alex from "../imgs/Alex.jpeg";
import Isabella from "../imgs/Isabella.jpeg";
import Sydni from "../imgs/Sydni.JPG";
import Esha from "../imgs/esha.jpg";
import Chloe from "../imgs/Chloe.JPG";
import Allison_F from "../imgs/Allison_F.jpeg";
import Michelle from "../imgs/Michelle.jpeg";
import Jen from "../imgs/Jen's headshots.png";
import Luna from "../imgs/Luna.jpeg";
import Emily from "../imgs/Emily.jpeg";
import Lydia from "../imgs/Lydia.jpeg";
import Raven from "../imgs/Raven.jpg";
import Sienna from "../imgs/Sienna.jpg";
import Sharika from "../imgs/Sharika.jpeg";
import Trinity from "../imgs/trinity.jpg";
import Aily from "../imgs/Aily.JPG"

const Officers = () => {
  return (
    <div className="home">
      <div className="blackText">
        <div className="navbarSpace"></div>
        <div className="header-title">Executive Board</div>
      </div>

      <div className="row-container">
        <div className="officer-container">
          <div className="subtitles">President</div>
          <div className="circle-container">
            <img className="circle_pic" src={Allison_F} alt="President" />
          </div>
          <div className="subtitles">Allison Freeman</div>
          <div className="info">Electrical Engineering</div>
          <div className="info">4th year</div>
          <div className="infoLinks">
            <LinkedInIcon style={{ width: '3vw', height: '3vw' }} onClick={() => window.open("https://www.linkedin.com/in/allison-freeman-")} />
            <EmailIcon style={{ width: '3vw', height: '3vw' }} onClick={() => (window.location = "mailto:president.wece@gmail.com")} />
          </div>
        </div>

        <div className="officer-container">
          <div className="subtitles">VP Internal</div>
          <div className="circle-container">
            <img className="circle_pic" src={Isabella} alt="VP Internal" />
          </div>
          <div className="subtitles">Isabella Cratem</div>
          <div className="info">Electrical Engineering</div>
          <div className="info">4th year</div>
          <div className="infoLinks">
            <LinkedInIcon style={{ width: '3vw', height: '3vw' }} onClick={() => window.open("https://www.linkedin.com/in/isabella-cratem?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app")} />
            <EmailIcon style={{ width: '3vw', height: '3vw' }} onClick={() => (window.location = "mailto:vpinternal.wece@gmail.com")} />
          </div>
        </div>

        <div className="officer-container">
          <div className="subtitles">VP External</div>
          <div className="circle-container">
            <img className="circle_pic" src={Chloe} alt="VP External" />
          </div>
          <div className="subtitles">Chloe Sawatzki</div>
          <div className="info">Computer Engineering</div>
          <div className="info">4th year</div>
          <div className="infoLinks">
            <LinkedInIcon style={{ width: '3vw', height: '3vw' }} onClick={() => window.open("http://www.linkedin.com/in/chloe-sawatzki")} />
            <EmailIcon style={{ width: '3vw', height: '3vw' }} onClick={() => (window.location = "mailto:vpexternal.wece@gmail.com")} />
          </div>
        </div>
      </div>

      <div className="row-container">
        <div className="officer-container">
          <div className="subtitles">Secretary</div>
          <div className="circle-container">
            <img className="circle_pic" src={Christa} alt="Secretary" />
          </div>
          <div className="subtitles">Christa Riddlemoser</div>
          <div className="info">Electrical Engineering</div>
          <div className="info">5th year</div>
          <div className="infoLinks">
            <LinkedInIcon style={{ width: '3vw', height: '3vw' }} onClick={() => window.open("https://www.linkedin.com/in/christa-riddlemoser-78028a292")} />
            <EmailIcon style={{ width: '3vw', height: '3vw' }} onClick={() => (window.location = "mailto:secretary.wece@gmail.com")} />
          </div>
        </div>

        <div className="officer-container">
          <div className="subtitles">Treasurer</div>
          <div className="circle-container">
            <img className="circle_pic" src={Esha} alt="Treasurer" />
          </div>
          <div className="subtitles">Esha Patel</div>
          <div className="info">Computer Science</div>
          <div className="info">3rd year</div>
          <div className="infoLinks">
            <LinkedInIcon style={{ width: '3vw', height: '3vw' }} onClick={() => window.open("https://www.linkedin.com/in/esha-m-patel")} />
            <EmailIcon style={{ width: '3vw', height: '3vw' }} onClick={() => (window.location = "mailto:treasurer.wece@gmail.com")} />
          </div>
        </div>
      </div>

      <div className="blackText">
       <div className="header-title">Officers</div>
      </div>
      <div className="row-container">
       <div className="officer-container">
          <div className="subtitles">Curriculum Chair</div>
          <div className="circle-container">
            <img
              className="circle_pic" src={Sharika} alt="CpE Curriculum Chair"
            />
          </div>
          <div className="subtitles">Sharika Khondaker</div>
          <div className="info">Computer Engineering</div>
          <div className="info">4th year</div>
          <div className="infoLinks">
            <LinkedInIcon style={{ width: '3vw', height: '3vw' }} onClick={() => window.open("https://www.linkedin.com/in/sharika-khondaker")} />
            <EmailIcon style={{ width: '3vw', height: '3vw' }} onClick={() => (window.location = "mailto:curriculum.wece@gmail.com")} />
          </div>
        </div> 

        <div className="officer-container">
          <div className="subtitles">Event Coordinator</div>
          <div className="circle-container">
            <img className="circle_pic" src={Jen} alt="Event Coordinator" />
          </div>
          <div className="subtitles">Jennifer Senra Bruzon</div>
          <div className="info">Electrical Engineering</div>
          <div className="info">4th year</div>
          <div className="infoLinks">
            <LinkedInIcon style={{ width: '3vw', height: '3vw' }} onClick={() => window.open("http://linkedin.com/in/jennifersenra")} />
            <EmailIcon style={{ width: '3vw', height: '3vw' }} onClick={() => (window.location = "mailto:eventcoordinator.wece@gmail.com")} />
          </div>
        </div>

        <div className="officer-container">
          <div className="subtitles">Event Coordinator</div>
          <div className="circle-container">
            <img className="circle_pic" src={Luna} alt="Event Coordinator" />
          </div>
          <div className="subtitles">Luna Khan</div>
          <div className="info">Computer Engineering </div>
          <div className="info">4th year</div>
          <div className="infoLinks">
            <LinkedInIcon style={{ width: '3vw', height: '3vw' }} onClick={() => window.open("https://linkedin.com/in/luna-khan")} />
            <EmailIcon style={{ width: '3vw', height: '3vw' }} onClick={() => (window.location = "mailto:eventcoordinator.wece@gmail.com")} />
          </div>
        </div>
      </div>

      <div className="row-container">
      <div className="officer-container">
          <div className="subtitles">Graphic Design Chair</div>
          <div className="circle-container">
            <img className="circle_pic" src={Michelle} alt="Graphic Design Chair" />
          </div>
          <div className="subtitles">Michelle Garcia</div>
          <div className="info">Computer Engineering</div>
          <div className="info">4th year</div>
          <div className="infoLinks">
            <LinkedInIcon style={{ width: '3vw', height: '3vw' }} onClick={() => window.open("https://www.linkedin.com/in/michellegarciaee")} />
            <EmailIcon style={{ width: '3vw', height: '3vw' }} onClick={() => (window.location = "mailto:eventcoordinator.wece@gmail.com")} />
          </div>
        </div>

            <div className="officer-container">
          <div className="subtitles">Tech Workshop Chair</div>
          <div className="circle-container">
            <img className="circle_pic" src={Lydia} alt="Tech Workshop Chair" />
          </div>
          <div className="subtitles">Lydia Chung</div>
          <div className="info">Computer Engineering</div>
          <div className="info">4th year</div>
          <div className="infoLinks">
            <LinkedInIcon style={{ width: '3vw', height: '3vw' }} onClick={() => window.open("https://www.linkedin.com/in/lgchung5")} />
            <EmailIcon style={{ width: '3vw', height: '3vw' }} onClick={() => (window.location = "mailto:workshops.wece@gmail.com")} />
          </div>
        </div>

        <div className="officer-container">
          <div className="subtitles">Tech Workshop Chair</div>
          <div className="circle-container">
            <img className="circle_pic" src={Sienna} alt="Tech Workshop Chair" />
          </div>
          <div className="subtitles">Sienna Perez</div>
          <div className="info">Computer Science</div>
          <div className="info">2nd year</div>
          <div className="infoLinks">
            <LinkedInIcon style={{ width: '3vw', height: '3vw' }} onClick={() => window.open("https://www.linkedin.com/in/siennaperez")} />
            <EmailIcon style={{ width: '3vw', height: '3vw' }} onClick={() => (window.location = "mailto:workshops.wece@gmail.com")} />
          </div>
        </div>
      </div>
      
      <div className="row-container">
        <div className="officer-container">
          <div className="subtitles">PR Chair</div>
          <div className="circle-container">
            <img
              className="circle_pic" src={Emily} alt="PR Chair"
            />
          </div>
          <div className="subtitles">Emily D'Alessandro</div>
          <div className="info">Electrical Engineering</div>
          <div className="info">3rd year</div>
          <div className="infoLinks">
            <LinkedInIcon style={{ width: '3vw', height: '3vw' }} onClick={() => window.open("https://www.linkedin.com/in/emily-d-alessandro-4242622a4?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app")} />
            <EmailIcon style={{ width: '3vw', height: '3vw' }} onClick={() => (window.location = "mailto:mentorship.wece@gmail.com")} />
          </div>
        </div>

        <div className="officer-container">
          <div className="subtitles">Recruitment Chair</div>
          <div className="circle-container">
            <img
              className="circle_pic" src={Trinity} alt="Recruitment Chair"/>
          </div>
          <div className="subtitles">Trinity Saunders</div>
          <div className="info">Computer Engineering</div>
          <div className="info">2nd year</div>
          <div className="infoLinks">
            <LinkedInIcon style={{ width: '3vw', height: '3vw' }} onClick={() => window.open("https://www.linkedin.com/in/trinity-saunders-50675828a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app")} />
            <EmailIcon style={{ width: '3vw', height: '3vw' }} onClick={() => (window.location = "mailto:Trinity.saunders@ufl.edu")} />
          </div>
        </div>

        <div className="officer-container">
          <div className="subtitles">Corporate Liaison</div>
          <div className="circle-container">
            <img className="circle_pic" src={Sydni} alt="Corporate Liaison" />
          </div>
          <div className="subtitles">Sydni-Noel Levy Davis</div>
          <div className="info">Computer Engineering</div>
          <div className="info">3rd year</div>
          <div className="infoLinks">
            <LinkedInIcon style={{ width: '3vw', height: '3vw' }} onClick={() => window.open("http://www.linkedin.com/in/sdlevydavis")} />
            <EmailIcon style={{ width: '3vw', height: '3vw' }} onClick={() => (window.location = "mailto:corporateliaison.wece@gmail.com")} />
          </div>
        </div>
      </div>

      <div className="row-container">
      <div className="officer-container">
          <div className="subtitles">Outreach Coordinator</div>
          <div className="circle-container">
            <img className="circle_pic" src={Aily} alt="Outreach Coordinator" />
          </div>
          <div className="subtitles">Aily Mai</div>
          <div className="info">Computer Engineering</div>
          <div className="info">3rd year</div>
          <div className="infoLinks">
            <LinkedInIcon style={{ width: '3vw', height: '3vw' }} onClick={() => window.open("https://www.linkedin.com/in/aily-mai/")} />
            <EmailIcon style={{ width: '3vw', height: '3vw' }} onClick={() => (window.location = "mailto:outreach.wece@gmail.com")} />
          </div>
        </div>

        <div className="officer-container">
          <div className="subtitles">Webmaster</div>
          <div className="circle-container">
            <img className="circle_pic" src={Alex} alt="Webmaster" />
          </div>
          <div className="subtitles">Alexandra Seelig</div>
          <div className="info">Computer Engineering</div>
          <div className="info">4th year</div>
          <div className="infoLinks">
            <LinkedInIcon style={{ width: '3vw', height: '3vw' }} onClick={() => window.open("https://www.linkedin.com/in/seeliga/")} />
            <EmailIcon style={{ width: '3vw', height: '3vw' }} onClick={() => (window.location = "mailto:webmaster.wece@gmail.com")} />
          </div>
        </div>

        <div className="officer-container">
          <div className="subtitles">Webmaster</div>
          <div className="circle-container">
            <img className="circle_pic" src={Raven} alt="Webmaster" />
          </div>
          <div className="subtitles">Raven Kim Ramos</div>
          <div className="info">Electrical & Computer Engineering</div>
          <div className="info">Grad Student </div>
          <div className="infoLinks">
            <LinkedInIcon style={{ width: '3vw', height: '3vw' }} onClick={() => window.open("https://www.linkedin.com/in/ravenkimramos/")} />
            <EmailIcon style={{ width: '3vw', height: '3vw' }} onClick={() => (window.location = "mailto:webmaster.wece@gmail.com")} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Officers;
